<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/o0XFTN/tc-custom/9781611177190.jpg?1726871242708" alt="This image is the cover for the book Martyr of the American Revolution"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Martyr of the American Revolution
      </h1>
      <p class="bookDescription body article font2">
        <b>This military history examines the complex factors surrounding the execution of an American militia colonel in British-occupied Charleston, SC.</b><br/><br/>South Carolina patriot militiamen played an integral role in helping the Continental army reclaim their state from its British conquerors. In <i>Martyr of the American Revolution</i>, Cordell L. Bragg, III, examines the events that set Col. Isaac Hayne into a disastrous conflict with two British officers, his execution in Charleston, and the repercussions that extended from South Carolina to the Continental Congress and the halls of British Parliament.<br/><br/>Hayne was the most prominent American executed by the British for treason. He and his two principal antagonists, Lt. Col. Nisbet Balfour and Lt. Col. Francis Lord Rawdon, were unwittingly set on a collision course that climaxed in an act that sparked one of the war’s most notable controversies. <i>Martyr of the American Revolution</i> sheds light on why two professional soldiers were driven to commit a seemingly arbitrary deed that halted prisoner exchange and nearly brought disastrous consequences to captive British officers.<br/><br/>The death of a patriot in the cause of liberty was not a unique occurrence, but the unusually well-documented events surrounding the execution of Hayne and the involvement of his friends and family makes his story compelling and poignant. Unlike young Capt. Nathan Hale, who suffered a similar fate in 1776, Hayne did not become a folk hero. Yet his execution became an international affair debated in both Parliament and the Continental Congress.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        C. L. Bragg
      </h2>
      
      <p class="authorDescription body article"><P>C. L. "Chip" Bragg is a practicing anesthesiologist in Thomasville, Georgia. His lifelong passion for American history has resulted in three previously published books: Distinction in Every Service: Brigadier General Marcellus A. Stovall, C.S.A., the critically acclaimed Never for Want of Powder: The Confederate Powder Works in Augusta, Georgia, of which he is coauthor, and Crescent Moon over Carolina: William Moultrie and American Liberty.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of South Carolina Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?390df31b